/*
 * USD / KRW switcher backed by Shopify Markets (switches the storefront country).
 * - Only touches elements marked with [data-mm-price]; no page-wide text scanning.
 * - Prices are rendered by Shopify in the active market currency; checkout uses the same currency.
 */
(function () {
  var BASE = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  var TARGETS = { USD: '$', KRW: '₩' };
  var KEY = 'mm-currency';
  var RATE_KEY = 'mm-currency-rate';
  var RATE_TTL = 12 * 60 * 60 * 1000;
  var FALLBACK = { USD: { KRW: 1400 }, KRW: { USD: 1 / 1400 } };
  var current = BASE;
  var rate = null; // multiplier from BASE to the chosen currency
  var pending = new Set();
  var scheduled = false;

  function read(key) { try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; } }
  function write(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {} }

  function parseAmount(text) {
    var m = /(\d{1,3}(?:,\d{3})*(?:\.\d+)?|\d+(?:\.\d+)?)/.exec(text);
    return m ? parseFloat(m[1].replace(/,/g, '')) : null;
  }

  function formatAmount(value, code) {
    if (code === 'KRW') return '₩' + Math.round(value).toLocaleString('en-US');
    return '$' + value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function needsRate() {
    return current !== BASE && !!TARGETS[current] && !!TARGETS[BASE];
  }

  function render(el) {
    var shown = el.getAttribute('data-mm-shown');
    var text = el.textContent;
    // Text we did not write: the theme re-rendered this price, so it is a new original.
    if (shown === null || text !== shown) {
      el.setAttribute('data-mm-base', text);
    }
    var base = el.getAttribute('data-mm-base');
    var out = base;
    if (current !== BASE && TARGETS[current] && TARGETS[BASE]) {
      var amount = parseAmount(base);
      if (amount !== null && rate) out = formatAmount(amount * rate, current);
    }
    if (out !== text) el.textContent = out;
    el.setAttribute('data-mm-shown', out);
  }

  function flush() {
    scheduled = false;
    var items = Array.from(pending);
    pending.clear();
    items.forEach(function (el) { if (el.isConnected) render(el); });
  }

  function queue(el) {
    pending.add(el);
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(flush);
    }
  }

  function renderAll() {
    document.querySelectorAll('[data-mm-price]').forEach(queue);
    document.querySelectorAll('[data-mm-currency-symbol]').forEach(function (el) { el.textContent = TARGETS[current]; });
    document.querySelectorAll('[data-mm-currency-option]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-mm-currency-option') === current);
    });
  }

  function ensureRate() {
    var fallback = (FALLBACK[BASE] || {})[current] || 1;
    var cached = read(RATE_KEY);
    if (cached && cached.base === BASE && cached.target === current && Date.now() - cached.time < RATE_TTL) {
      rate = cached.rate;
      return Promise.resolve();
    }
    return fetch('https://open.er-api.com/v6/latest/' + BASE)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        rate = data && data.rates && data.rates[current] ? data.rates[current] : fallback;
        write(RATE_KEY, { base: BASE, target: current, time: Date.now(), rate: rate });
      })
      .catch(function () { rate = fallback; });
  }

  function setCurrency(code) {
    if (!TARGETS[code]) return;
    current = code;
    write(KEY, code);
    rate = null;
    if (needsRate()) ensureRate().then(renderAll);
    else renderAll();
  }

  // Each currency is a Shopify market: USD = International (via US), KRW = South Korea.
  var MARKET_COUNTRY = { USD: 'US', KRW: 'KR' };

  function switchMarket(code) {
    var country = MARKET_COUNTRY[code];
    if (!country || code === BASE) return;
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/localization';
    [['form_type', 'localization'], ['_method', 'put'], ['country_code', country], ['return_to', location.pathname + location.search]]
      .forEach(function (pair) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = pair[0];
        input.value = pair[1];
        form.appendChild(input);
      });
    document.body.appendChild(form);
    form.submit();
  }

  function openList(list) {
    if (list._closeTimer) { clearTimeout(list._closeTimer); list._closeTimer = null; }
    list.hidden = false;
    void list.offsetHeight; // let the browser register the closed state so the open animates
    list.classList.add('is-open');
    var toggle = list.parentElement.querySelector('[data-mm-currency-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function closeList(list) {
    if (list.hidden || !list.classList.contains('is-open')) return;
    list.classList.remove('is-open');
    var toggle = list.parentElement.querySelector('[data-mm-currency-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    list._closeTimer = setTimeout(function () { list.hidden = true; list._closeTimer = null; }, 750);
  }

  function closeLists(except) {
    document.querySelectorAll('[data-mm-currency-list]').forEach(function (list) {
      if (list !== except) closeList(list);
    });
  }

  function init() {
    // Prices now come from Shopify Markets in the active currency, so no display conversion is applied.
    try { localStorage.removeItem(KEY); } catch (e) {}

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-mm-currency-toggle]');
      if (toggle) {
        var list = toggle.parentElement.querySelector('[data-mm-currency-list]');
        if (list) {
          if (list.hidden || !list.classList.contains('is-open')) { closeLists(list); openList(list); }
          else closeList(list);
        }
        return;
      }
      var option = event.target.closest('[data-mm-currency-option]');
      if (option) {
        switchMarket(option.getAttribute('data-mm-currency-option'));
        closeLists();
        return;
      }
      closeLists();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeLists();
    });

    // Cheap observer: child-list changes only, and only inspects added nodes / changed price elements.
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var target = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        var owner = target && target.closest ? target.closest('[data-mm-price]') : null;
        if (owner) queue(owner);
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.hasAttribute('data-mm-price')) queue(node);
          if (node.firstElementChild) node.querySelectorAll('[data-mm-price]').forEach(queue);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    if (needsRate()) ensureRate().then(renderAll);
    else renderAll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
